export const review = {
    writingPlaceholder: "Please describe your evaluation of grades, load, etc.",
    like: "Like ",
    notOpenYet: "You can write a review after the course drop period",
}
